// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRoleLiteDto } from './IRoleLiteDto';
import {
    IRoleLiteDtoFromJSON,
    IRoleLiteDtoFromJSONTyped,
    IRoleLiteDtoToJSON,
    IRoleLiteDtoToJSONTyped,
} from './IRoleLiteDto';

/**
 * 
 * @export
 * @interface IRolesAvailableForIdentityDto
 */
export interface IRolesAvailableForIdentityDto {
    /**
     * 
     * @type {Set<IRoleLiteDto>}
     * @memberof IRolesAvailableForIdentityDto
     */
    allowed_for_creation_by_user?: Set<IRoleLiteDto>;
    /**
     * 
     * @type {Set<IRoleLiteDto>}
     * @memberof IRolesAvailableForIdentityDto
     */
    allowed_for_organization?: Set<IRoleLiteDto>;
}

/**
 * Check if a given object implements the IRolesAvailableForIdentityDto interface.
 */
export function instanceOfIRolesAvailableForIdentityDto(value: object): value is IRolesAvailableForIdentityDto {
    return true;
}

export function IRolesAvailableForIdentityDtoFromJSON(json: any): IRolesAvailableForIdentityDto {
    return IRolesAvailableForIdentityDtoFromJSONTyped(json, false);
}

export function IRolesAvailableForIdentityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRolesAvailableForIdentityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'allowed_for_creation_by_user': json['allowed_for_creation_by_user'] == null ? undefined : (new Set((json['allowed_for_creation_by_user'] as Array<any>).map(IRoleLiteDtoFromJSON))),
        'allowed_for_organization': json['allowed_for_organization'] == null ? undefined : (new Set((json['allowed_for_organization'] as Array<any>).map(IRoleLiteDtoFromJSON))),
    };
}

export function IRolesAvailableForIdentityDtoToJSON(json: any): IRolesAvailableForIdentityDto {
    return IRolesAvailableForIdentityDtoToJSONTyped(json, false);
}

export function IRolesAvailableForIdentityDtoToJSONTyped(value?: IRolesAvailableForIdentityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowed_for_creation_by_user': value['allowed_for_creation_by_user'] == null ? undefined : (Array.from(value['allowed_for_creation_by_user'] as Set<any>).map(IRoleLiteDtoToJSON)),
        'allowed_for_organization': value['allowed_for_organization'] == null ? undefined : (Array.from(value['allowed_for_organization'] as Set<any>).map(IRoleLiteDtoToJSON)),
    };
}

